module.exports = {
    ...require('ok-funds-card/constants/index'),
    PRODUCTION_ENVIRONMENT: 'PRODUCCION',
    EURO_SYMBOL: '€',
    EURO_TEXT: 'EUR',
    SUNDAY_INDEX_DAY: 0,
    SATURDAY_INDEX_DAY: 6,
    BROKER_SIMPLE_SEARCH_PAGE_NUM: '1',
    BROKER_PRODUCT_SEARCH_GROUP_LIMIT: 10,
    BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT: 5,
    BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10: 10,
    BROKER_PRODUCT_ADVANCED_SEARCH_ALL_OPTIONS: '0',
    BROKER_PRODUCT_ADVANCED_SEARCH_CURRENCY: 'currencyValues',
    BROKER_PRODUCT_ADVANCED_SEARCH_ASSET_TYPES: 'assetClassValues',
    BROKER_PRODUCT_ADVANCED_SEARCH_RISK: 'riskValues',
    BROKER_PRODUCT_ADVANCED_SEARCH_SUB_ASSET_TYPE: 'subAssetClassValues',
    BROKER_PRODUCT_ADVANCED_SEARCH_MARKET: 'marketValues',
    BROKER_PRODUCT_ADVANCED_SEARCH_MANAGER: 'managerValues',
    BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES: 'productCategoryValues',
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM: 'term',
    DATE_PICKER_CUSTOM_PLACEHOLDER: 'datePickerCustom-placeholder',
    DATE_PICKER_CUSTOM_LOCALE: 'datePickerCustom-locale',
    DATE_PICKER_CUSTOM_DATE_FORMAT: 'datePickerCustom-dateFormat',
    DATE_PICKER_LOWERCASE_MONTH_COUNTRIES: ['PT'],
};
